export default __webpack_public_path__ + "static/12_35-7db5d81b6795249d07b3b9a4aa182a47.png";